import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Pages to exclude from analytics tracking (admin and auth pages)
const EXCLUDED_PATHS = [
  '/admin',
  '/login',
  '/register',
  '/forgot-password',
  '/dashboard'
];

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if current path should be excluded from tracking
    const shouldExclude = EXCLUDED_PATHS.some(
      excludedPath => location.pathname.startsWith(excludedPath)
    );

    // Only track public website visitor pages
    if (shouldExclude) {
      return;
    }

    // Track page view
    const trackPageView = async () => {
      try {
        await axios.post(`${API}/api/analytics/track`, {
          page: location.pathname,
          referrer: document.referrer || '',
          user_agent: navigator.userAgent
        });
      } catch (error) {
        // Silently fail - don't break the app if tracking fails
        console.debug('Analytics tracking failed:', error.message);
      }
    };

    trackPageView();
  }, [location.pathname]);
};

export default usePageTracking;
